<template>
  <div v-if="contactId">
    <div v-if="!isDashboardAvailable">
      <p class="text-center text-muted">No permission available for contact dashboard</p>
    </div>
    <div v-if="isDashboardAvailable">
      <div class="row no-gutter" v-if="isCreditTypeAccount">
        <div class="col-12" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceAccount)">
          <CustomerAgedBalanceChartWidget :contactId="contactId">
          </CustomerAgedBalanceChartWidget>
        </div>
      </div>
      <div class="row no-gutter" v-if="isCreditTypeAccount">
        <div class="col-12" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceAccount)">
          <AccountsReceivableSummaryWidget :contactId="contactId" :gridHeight="320" />
        </div>
      </div>
      <div class="row no-gutter">
        <div class="col-12" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder) || userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceAccount)">
          <FinancialBreakdownWidget :contactId="contactId" :gridHeight="350" />
        </div>
      </div>
      <div class="row no-gutter" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder)">
        <div class="col-12">
          <DashboardTabbedContentBox :gridHeight="600" large>
            <template v-slot:tablist>
              <Tab :first="true" tabid="tab-order-daily">
                <i class="tabbedbox-tab-icon fas fa-calendar-day"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">Daily</div>
                  <div class="tabbedbox-tab-subtitle">Order Value Chart</div>
                </div>
              </Tab>
              <Tab tabid="tab-order-monthly">
                <i class="tabbedbox-tab-icon fas fa-calendar-alt"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">Monthly</div>
                  <div class="tabbedbox-tab-subtitle">Order Value Chart</div>
                </div>
              </Tab>
            </template>
            <template v-slot:tabcontent>
              <TabPage :first="true" tabid="tab-order-daily" class="tabpage-padding-0">
                <OrderDailyChartWidget :gridHeight="540" :embedded="true" :contactId="contactId" />
              </TabPage>
              <TabPage tabid="tab-order-monthly" class="tabpage-padding-0">
                <OrderMonthlyChartWidget :gridHeight="540" :embedded="true" :contactId="contactId" />
              </TabPage>
            </template>
          </DashboardTabbedContentBox>
        </div>
      </div>
      <div class="row no-gutter" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder)">
        <div class="col-6">
          <OrderValueChartWidget :dateRangeType="ChartDateRangeTypes.allTime" type="orderValueGlass" title="All Orders By Glass" subTitle="Total order value broken down by glass stock type for the contact. Incl GST" :gridHeight="500" :contactId="contactId" />
        </div>
        <div class="col-6">
          <OrderValueChartWidget :dateRangeType="ChartDateRangeTypes.allTime" type="orderValuePriceGroup" title="All Orders By Price Group" subTitle="Total order value broken down by price group for the contact. Incl GST" :gridHeight="500" :contactId="contactId" />
        </div>                
      </div>
      <div class="row no-gutter">
        <div class="col-6" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder)">
          <OrderValueChartWidget :dateRangeType="ChartDateRangeTypes.allTime" type="orderUnitsGlass" title="All Orders By Glass Square Meterage" subTitle="Total square meterage broken down by glass stock type for the contact" :gridHeight="500" :contactId="contactId" />
        </div>
        <div class="col-6" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder)">
          <OrderValueChartWidget :dateRangeType="ChartDateRangeTypes.allTime" type="orderValueGlassService" title="All Orders By Glass Service" subTitle="Total order value broken down by glass service type for the contact. Incl GST" :gridHeight="500" :contactId="contactId" />
        </div>
      </div>
      <div class="row no-gutter" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceAccount)">
        <div class="col-12">
          <DashboardTabbedContentBox :gridHeight="600" large>
            <template v-slot:tablist>
              <Tab :first="true" tabid="tab-invoice-daily">
                <i class="tabbedbox-tab-icon fas fa-calendar-day"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">Daily</div>
                  <div class="tabbedbox-tab-subtitle">Invoice Value Chart</div>
                </div>
              </Tab>
              <Tab tabid="tab-invoice-monthly">
                <i class="tabbedbox-tab-icon fas fa-calendar-alt"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">Monthly</div>
                  <div class="tabbedbox-tab-subtitle">Invoice Value Chart</div>
                </div>
              </Tab>
            </template>
            <template v-slot:tabcontent>
              <TabPage :first="true" tabid="tab-invoice-daily" class="tabpage-padding-0">
                <InvoiceDailyChartWidget :gridHeight="540" :embedded="true" :contactId="contactId" />
              </TabPage>
              <TabPage tabid="tab-invoice-monthly" class="tabpage-padding-0">
                <InvoiceMonthlyChartWidget :gridHeight="540" :embedded="true" :contactId="contactId" />
              </TabPage>
            </template>
          </DashboardTabbedContentBox>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import CustomerAgedBalanceChartWidget from '@/modules/intelligence/dashboardWidgets/customerAgedBalanceChartWidget'
import AccountsReceivableSummaryWidget from '@/modules/intelligence/dashboardWidgets/accountsReceivableSummaryWidget'
import FinancialBreakdownWidget from '@/modules/intelligence/dashboardWidgets/financialBreakdownWidget'
import OrderValueChartWidget from '@/modules/intelligence/dashboardWidgets/orderValueChartWidget'
import OrderDailyChartWidget from '@/modules/intelligence/dashboardWidgets/orderDailyChartWidget'
import OrderMonthlyChartWidget from '@/modules/intelligence/dashboardWidgets/orderMonthlyChartWidget'
import InvoiceDailyChartWidget from '@/modules/intelligence/dashboardWidgets/invoiceDailyChartWidget'
import InvoiceMonthlyChartWidget from '@/modules/intelligence/dashboardWidgets/invoiceMonthlyChartWidget'

import { CreditTypes } from '@/store/types'
import { ChartDateRangeTypes } from '@/modules/intelligence/types'

export default {
  name: 'AnalyticsContactDashboard',
  components: {
    DashboardContentBox,
    DashboardTabbedContentBox,
    AnalyticsWidget,
    CustomerAgedBalanceChartWidget,
    AccountsReceivableSummaryWidget,
    FinancialBreakdownWidget,
    OrderValueChartWidget,
    OrderDailyChartWidget,
    OrderMonthlyChartWidget,
    InvoiceDailyChartWidget,
    InvoiceMonthlyChartWidget
  },
  props: {
    creditType: String,
    contactId: Number
  },
  computed: {
    isCreditTypeAccount() {
      return this.creditType == CreditTypes.account
    },
    isDashboardAvailable() {
      if(this.userHasReadPermission(this.PermissionTypes.IntelligencePermissionTypes.intelligenceAccount) || this.userHasReadPermission(this.PermissionTypes.IntelligencePermissionTypes.intelligenceOrder))
        return true
      return false
    }
  },
  created() {
    this.ChartDateRangeTypes = ChartDateRangeTypes
  }
}
</script>